import { ShieldCheck, MapPin, Sparkles, HeartHandshake } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";

const benefits = [
  {
    icon: ShieldCheck,
    title: "Zertifizierte Beratung",
    text: "IHK-zertifizierter betrieblicher Mobilitätsmanager – fundiertes Fachwissen statt Verkaufsgerede.",
  },
  {
    icon: MapPin,
    title: "Regional & persönlich",
    text: "Direkt bei Frankfurt in Rödermark-Urbach. Übergabe, Einweisung und Rückgabe unkompliziert vor Ort.",
  },
  {
    icon: Sparkles,
    title: "Gepflegtes Fahrzeug",
    text: "Ein sauberer, top gewarteter Tesla – bereit für Ihre Probefahrt, Ausfahrt oder das erste E-Erlebnis.",
  },
  {
    icon: HeartHandshake,
    title: "Ehrlich & flexibel",
    text: "Schnelle Kommunikation, transparente Abwicklung und Ansprechpartner vor, während und nach der Miete.",
  },
];

export const Benefits = () => {
  useReveal();
  return (
    <section id="vorteile" data-testid="benefits-section" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl reveal">
          <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4">
            Warum wir
          </p>
          <h2 className="font-heading font-bold text-white tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight">
            Vertrauen, das man spürt – vom ersten Kontakt an.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              data-testid={`benefit-card-${i}`}
              className="reveal group rounded-2xl border border-white/10 bg-card p-8 hover:border-white/25 hover:-translate-y-1 transition-all duration-300"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="w-12 h-12 rounded-full border border-white/15 flex items-center justify-center mb-6 group-hover:border-white/40 transition-colors">
                <b.icon className="w-5 h-5 text-white" strokeWidth={1.5} />
              </div>
              <h3 className="font-heading font-semibold text-lg text-white mb-3">
                {b.title}
              </h3>
              <p className="text-sm text-white/60 leading-relaxed">{b.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
